$(document).ready(function () {
  var nekerProductTexture = $(".neker-detail-content.texture");
  if (nekerProductTexture.length > 0) {
    var nekerProductTextureSlider = new Swiper(nekerProductTexture, {
      slidesPerView: "auto",
      loop: true,
      navigation: {
        nextEl: ".neker-detail-content.texture .swiper-button-next",
        prevEl: ".neker-detail-content.texture .swiper-button-prev",
      },
      pagination: {
        el: ".neker-detail-content.texture .swiper-pagination",
        clickable: true,
      },
    });
  }
});
